
<context-display :context="context">
  <template #workarea>
    <span>Aggregate Function: <b>{{displayText}}</b></span>
  </template>
</context-display>
